/**
 * Extracts the domain from a given URL.
 *
 * This function takes a URL as input and returns the domain name without the 'www.' prefix.
 * If the URL is invalid or doesn't contain a hostname, an empty string is returned.
 *
 * @param {string} url - The URL from which to extract the domain.
 * @returns {string} The extracted domain name or an empty string if extraction fails.
 *
 * @example
 * getDomainFromUrl('https://www.example.com/page') // returns 'example.com'
 * getDomainFromUrl('http://subdomain.example.co.uk') // returns 'subdomain.example.co.uk'
 * getDomainFromUrl('invalid-url') // returns ''
 */
const getDomainFromUrl = (url: string): string => {
  try {
    const urlObject = new URL(url);
    if (!urlObject.hostname) return '';
    const domain = urlObject.hostname.replace(/^www\./, '');
    return domain;
  } catch (error) {
    // If URL is invalid, return an empty string
    return '';
  }
};

export default getDomainFromUrl;
